import { IDMap, Schema } from '../schema';

export enum SlideType {
  /** 封面 */
  cover = 'cover',
  /** 目录 */
  catalogue = 'catalogue',
  /** 章节 */
  session = 'session',
  /** 正文 */
  page = 'page',
  /** 尾页 */
  ending = 'ending',

  /** 组件 */
  component = 'component',
}

export type ISlideType = Exclude<SlideType, SlideType.component>;

export enum LegacySlideType {
  cover,
  catalogue,
  session,
  page,
  ending,
}

export interface LegacySlideTag {
  isTemplate: boolean;
  type: SlideType | LegacySlideType;

  /** 前端续写上下文 */
  continueWritingContext?: WritingContext;
}

export interface SlideTag {
  isTemplate: boolean;
  type: SlideType;

  /** 前端续写上下文 */
  continueWritingContext?: WritingContext;
}

export interface SlideTagExtra {
  type: SlideType;
  schema: Schema;
  idMap: IDMap;
  imageType: SlideImageType;
}

export enum ShapeType {
  title = 'title',
  content = 'content',
  list = 'list',
  image = 'image',
  chart = 'chart',
}

interface Common {
  isTemplate: true;
  type: ShapeType;
  canOmit: boolean;
  optional?: boolean;
}

interface Basic extends Common {
  type: ShapeType.title | ShapeType.content | ShapeType.image | ShapeType.chart;
}

export type Alignment = 'left' | 'center' | 'right';
export type AlignmentVertical = 'top' | 'center' | 'bottom';

interface List extends Common {
  type: ShapeType.list;

  alignment: Alignment;
  alignmentVertical: AlignmentVertical;
  scalable: boolean;
  minItemsCount: number;
}

export type ShapeTag = Basic | List;

export enum SlideImageType {
  Page = 'page',
  List = 'list',
  None = 'none',
}

export interface WritingContext {
  outline: string;
  templateId: string;
  conversationId?: string;
  messageId?: string;
  enableImageGeneration?: boolean;
}
